import React from 'react';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

import { LoadingStatus } from 'components/common/LoadingStatus/LoadingStatus';
import { Button, BUTTON } from 'components/common/Button/Button';
import styles from './AddEmailLayout.scss';

const AddEmailLayout = ({ title, onClose, isLoading, bodyContent, actionButton }) => {
    return (
        <div className={styles.drawerContainer} data-cy="AddEmailLayout">
            <div className={styles.drawerContainer__header}>
                <h3 data-id="email-config-drawer-title" data-cy="AddEmailLayout-title">{title}</h3>
                <IconButton aria-label="close" component="span" onClick={onClose} data-cy="AddEmailLayout-onClick">
                    <CloseIcon />
                </IconButton>
            </div>
            <div className={styles.drawerContainer__body}>
                {isLoading ? (
                    <LoadingStatus actionLabel={'loading'} itemName={''} loading={true} filterQuery={false} />
                ) : (
                    bodyContent
                )}
            </div>
            <div className={styles.drawerContainer__footer} data-cy="AddEmailLayout-actionButton">
                <Button
                    className={styles.drawerContainer__footer__cancelBtn}
                    bgcolor={BUTTON.BGCOLOR.WHITE}
                    color={BUTTON.COLOR.BLACK}
                    onClick={onClose}
                    data-id="cancel-button"
                    data-cy="AddEmailLayout-Cancel"
                >
                    Cancel
                </Button>
                {actionButton}
            </div>
        </div>
    );
};

export default AddEmailLayout;